function Wave6Mobile(props) {
   return(
      <svg className="wave-top rotate" xmlns="http://www.w3.org/2000/svg" width="374.002" height="57.986" viewBox="0 0 374.002 57.986">
         <path id="Wave_6" d="M11770.5,12991.992h-374v-20.061c20.563,12.336,46.738,18.856,75.7,18.856a207.59,207.59,0,0,0,29.545-2.168,231.071,231.071,0,0,0,30.271-6.5,246.156,246.156,0,0,0,30.247-10.835,252.046,252.046,0,0,0,29.472-15.164,129.757,129.757,0,0,1,22.8-10.705,174.2,174.2,0,0,1,24.746-6.8,260.283,260.283,0,0,1,50.728-4.611c9.438,0,19.29.411,29.281,1.223,8.164.663,16.466,1.594,24.676,2.768,14.2,2.03,23.9,4.172,26.535,4.779v49.216Z" transform="translate(-11396.499 -12934.006)" fill="#fff"/>
      </svg>
   )
}

export default Wave6Mobile;